import React from 'react';

const FrontPadIcon = () => (
  <svg 
    version="1.0" 
    xmlns="http://www.w3.org/2000/svg" 
    preserveAspectRatio="xMidYMid meet" 
    viewBox="0 -0.05 151 97.1" 
    fill="#0a2540"
    style={{ width: '24px', height: '24px' }}
  >
    <g transform="translate(0.000000,120.000000) scale(0.100000,-0.100000)" stroke="none">
      <path d="M45 1188 c-41 -24 -44 -38 -45 -195 0 -163 7 -194 47 -212 16 -7 121 -11 309 -11 l286 0 29 29 29 29 0 151 c0 161 -7 192 -47 210 -34 16 -581 15 -608 -1z m570 -203 l0 -130 -265 0 -265 0 -3 119 c-1 66 0 126 2 133 4 11 57 13 268 11 l263 -3 0 -130z"/>
      <path d="M854 1188 c-37 -17 -44 -51 -44 -209 l0 -151 29 -29 29 -29 286 0 c188 0 293 4 309 11 40 18 47 49 47 212 -1 159 -4 173 -47 195 -28 15 -578 15 -609 0z"/>
      <path d="M44 648 c-37 -18 -44 -51 -44 -211 1 -159 4 -173 47 -195 30 -16 572 -17 606 -1 40 18 47 49 47 210 l0 151 -29 29 -29 29 -289 -1 c-176 0 -296 -4 -309 -11z"/>
      <path d="M839 631 l-29 -29 0 -151 c0 -161 7 -192 47 -210 34 -16 576 -15 606 1 43 22 46 36 47 195 0 163 -7 194 -47 212 -16 7 -121 11 -309 11 l-286 0 -29 -29z"/>
    </g>
  </svg>
);

export default FrontPadIcon;